/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Apartment, House, Mail, PhoneAndroid} from "@mui/icons-material";
import epayco from './Recursos/ic_epayco.png'
import {useResponsive} from "../Modulo_responsive/Hooks/useResponsive";

const Footer = ({item}) => {
    const {sCell, masSM} = useResponsive()

    const IconoDatos = ({Icono, titulo, texto}) => {
        return (
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}>

                <Grid container size={{xs: 1, sm: 1, md: 1}}>
                    <Icono sx={{width: 24, height: 24}}/>
                </Grid>

                <Grid container size={{xs: 11, sm: 11, md: 11}} sx={{mt: 0.5, pl: 1}}>
                    <Typography sx={{fontWeight: 800, fontSize: 18, lineHeight: 1.1}}>{titulo} <span
                        style={{fontWeight: 300}}> {texto}</span></Typography>
                </Grid>


            </Grid>
        )
    }

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{borderTop: 4}}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3}}
            >


                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{mt: 6}}>
                    <Grid
                        container
                        justifyContent={sCell ? 'center' : 'flex-start'}
                        alignItems={'center'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 6, md: 4}} justifyContent={sCell ? 'center' : 'flex-start'}>
                            <img src={item.imgLogo} width={250} height={'auto'}/>
                        </Grid>

                        <Grid container size={{xs: 10, sm: 6, md: 4}} justifyContent={'center'}
                              sx={{mt: sCell ? 6 : 0}}
                        >
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                    <IconoDatos Icono={House} titulo={'Direccion: '} texto={item.direccion}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                                    <IconoDatos Icono={Apartment} titulo={'Ciudad: '} texto={item.ciudad}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                                    <IconoDatos Icono={PhoneAndroid} titulo={'Celular: '} texto={item.celular}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{mt: 1}}>
                                    <IconoDatos Icono={Mail} titulo={'Mail: '} texto={item.correo}/>
                                </Grid>


                            </Grid>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 4}}
                              sx={{mt: !masSM ? 6 : 0}}
                        >
                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}>


                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                    <Typography sx={{fontSize: 20, fontWeight: 800}}>Pago seguro</Typography>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'} sx={{mt: 1}}>
                                    <img src={epayco} width={150} height={'auto'}/>
                                </Grid>

                                <Grid container size={{xs: 12, sm: 12, md: 12}} justifyContent={'center'}>
                                    <Typography sx={{fontSize: 18, fontWeight: 400}}>ePayco by Davivienda</Typography>
                                </Grid>

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{backgroundColor: '#000', justifyContent: 'center', mt: 8, p: 1}}
            >
                <Typography sx={{color: '#fff'}}>© Copyright 2025 - 2026 | Jose Arturo</Typography>
            </Grid>

        </Grid>
    )

}
export default Footer